<script>
import BaseImageUrlMixin from '~/sites/shop/mixins/ImageUrlMixin'

export default {
  methods: {
    ...BaseImageUrlMixin.methods,
    imageBaseUrl() {
      const domainCdnUrl = this.$store?.state?.globals?.domain?.cdnUrl

      return (domainCdnUrl || this.$env.CDN_URL || this.$env.STORE_URL || '').replace(/\/+$/, '')
    },
    imageUrl({
      src,
      width = null,
      height = null,
      crop = false,
      imageStyle = 'custom',
      pixelRatio = 1,
      webP = false,
      upscale = false,
    }) {
      if (!src) return ''
      if (width === null || height === null) crop = true

      const w = width ? width * pixelRatio : null
      const h = height ? height * pixelRatio : null

      const url = [
        this.imageBaseUrl(),
        'image',
        imageStyle === 'original'
          ? imageStyle
          : [imageStyle, w ? 'w' + w : null, h ? 'h' + h : null, crop ? 'crop' : null, upscale ? 'upscale' : null]
              .filter(o => o)
              .join('-'),
        src,
      ].join('/')

      if (webP) {
        return url.replace(/(.*)\.(jpg|png)/, '$1.webp?original=$2')
      }

      return url
    },
  },
}
</script>
